<script setup lang="ts">
import TemplateDetailModalBody from './TemplateDetailModalBody.vue'

import type { CampaignType, TemplateData, TemplateDetail, TemplateLayout, TemplateModule } from '@/types/types'

const props = withDefaults(
  defineProps<{
    module: TemplateModule
    template: TemplateData
    layout?: TemplateLayout
  }>(),
  {
    layout: 'emptyState'
  }
)

const route = useRoute()
const { t } = useI18n()
const { applyTemplate, fetchTemplateDetail } = useTemplate()
const { send } = useEvent()

const isLoaded = ref(false)
const templateDetail = ref<TemplateDetail>()
const submodule = computed<CampaignType | null>(() => (route.query.type as CampaignType) || null)

const computedModule = computed(() => {
  return props.module === 'legacy-contests' ? 'contests' : props.module
})

const fetchTemplate = async () => {
  fillPreview(await fetchTemplateDetail(props.template.id))

  isLoaded.value = true
}
const fillPreview = (data) => {
  templateDetail.value = data
}
const buttonModal = computed(() => {
  let textButton
  if (props.layout === 'emptyState') {
    textButton = t(`pages.${computedModule.value}${submodule?.value ? `.${submodule.value}` : ''}.modal.buttonTitle`)
  } else {
    textButton = t(`pages.success.shortcut.shortcutType.template.${computedModule.value}.cta`)
  }
  return textButton
})

fetchTemplate()

const handleRedirect = async () => {
  if (templateDetail.value?.id) {
    send('segment', `${props.module}.template:new:clicked`, {
      templateId: templateDetail.value.id,
      module: props.module
    })
  }
  const routeQuery = {
    templateId: props.template.id,
    ...route.query
  }
  await applyTemplate(props.module, routeQuery)
}

defineExpose({ handleRedirect, buttonModal })
</script>
<template>
  <div v-if="isLoaded" class="flex flex-col justify-between">
    <div
      class="grid-rows-auto grid h-full w-full text-left sm:grid-rows-3 md:grid-rows-none lg:grid-cols-2 lg:grid-rows-none"
      :class="computedModule === 'survey-question' && 'sm:grid-rows-2 sm:auto-rows-min'"
    >
      <TemplateDetailModalBody :template-detail="templateDetail" :module="computedModule" :layout="layout" />
    </div>
  </div>
  <div v-else class="md:h-90">
    <div class="mb-6 flex flex-col gap-3 lg:flex-row">
      <div class="lg:w-1/2">
        <div
          class="mb-6 flex h-full flex-col rounded-sm border bg-muted px-12 py-32"
          :class="computedModule === 'contests' && 'items-center'"
        >
          <AppSkeleton type="text" class="h-80" :class="computedModule === 'contests' && 'w-64 h-96'" />
        </div>
      </div>
      <div class="px-12 py-6 lg:w-1/2">
        <AppSkeleton type="text" class="h-7 w-2/3" />
        <AppSkeleton type="text" class="mt-4 h-7 w-1/3" />
        <AppSkeleton type="text" class="mt-4 h-3" />
      </div>
    </div>
    <div class="flex justify-end p-2">
      <AppSkeleton type="button" class="h-7 w-28" />
    </div>
  </div>
</template>
